//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQRadio from "../../../../../components/Generics/AQRadio/AQRadio.vue";

export default {
    components: {
        AQRadio
    },
    data() {
        return {
            labelText: "Label",
            option: false,
            ceva: "one",
            clickValue7: "Seven",
            clickValue1: "Two",
            clickValue2: "Three",
            clickValue3: "Left Label",
            clickValue1bool: false,
            clickValue2bool: true,
            ceva2: false
        };
    },
    computed: {
    }
};
